module.exports = __webpack_public_path__ + "static/media/03-2-galeria-03-coach-mobile@2x.906eff92.jpg";